import * as T from '../../../../../../../components/Table';

export function Columns() {
  return (
    <T.Thead>
      <T.Th>Item</T.Th>
      <T.Th>Produto</T.Th>
      <T.Th>Cod</T.Th>
      <T.Th>Cor</T.Th>
      <T.Th>Personalização</T.Th>
      <T.Th>Quantidade</T.Th>
      <T.Th>Preço Venda</T.Th>
      <T.Th>Valor Total</T.Th>
      <T.Th>Caixa utilizada</T.Th>
      <T.Th>Quantidade de Caixas</T.Th>
      <T.Th>Peso por Caixa</T.Th>
      <T.Th>Peso Total</T.Th>
    </T.Thead>
  );
}
